import { render, staticRenderFns } from "./AddPrecioModal.vue?vue&type=template&id=396a0d4e"
import script from "./AddPrecioModal.vue?vue&type=script&lang=js"
export * from "./AddPrecioModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports